import { each, get } from 'lodash';

/**
 * Throw an error if given object don't have one of required props
 * @param object
 * @param props
 */
export function requiredProps(object: Record<string, any>, ...props: string[] | string[][]) {
    if (object && typeof object === 'object') {
        each(props, (prop) => {
            if (Array.isArray(prop)) {
                // $FlowFixMe
                requiredProps(object, prop);
            } else if (typeof prop === 'string') {
                if (!object.hasOwnProperty(prop) || !get(object, prop)) {
                    throw new Error(`Object property '${prop}' are required!`);
                }
            }
        });
    }
}
